import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { createPortal } from 'react-dom';
import StartPopup from '@/components/header/StartPopup';

type StartPopupContextValue = {
	openStartPopup: () => void;
	closeStartPopup: () => void;
	isStartPopupOpen: boolean;
};

const StartPopupContext = createContext<StartPopupContextValue | undefined>(undefined);

export function StartPopupProvider({ children }: { children: ReactNode }) {
	const [isStartPopupOpen, setIsStartPopupOpen] = useState(false);

	const value = useMemo(
		() => ({
			openStartPopup: () => setIsStartPopupOpen(true),
			closeStartPopup: () => setIsStartPopupOpen(false),
			isStartPopupOpen
		}),
		[isStartPopupOpen]
	);

	return (
		<StartPopupContext.Provider value={value}>
			{children}
			{isStartPopupOpen && createPortal(<StartPopup onClose={value.closeStartPopup} />, document.body)}
		</StartPopupContext.Provider>
	);
}

export function useStartPopup() {
	const context = useContext(StartPopupContext);
	if (!context) {
		throw new Error('useStartPopup must be used within StartPopupProvider');
	}
	return context;
}
